<script lang="ts">
  export let longestGreenStreak: number;
  export let greenCircles: number = 0;
  export let revealed: boolean = false;

  let totalPips = 12;
</script>

<div class="relative w-[300px] h-[420px] rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_30px_rgba(0,196,154,0.12)]" data-green-circles={greenCircles}>
  <!-- Night-sky style background for streak theme -->
  <div class="absolute inset-0 bg-[radial-gradient(120%_80%_at_50%_0%,#0b1f2a_0%,#0b2740_50%,#081524_100%)]"></div>
  <div class="absolute inset-0 opacity-[0.06] bg-[linear-gradient(0deg,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:16px_16px]"></div>
  <!-- Curvy pip ribbon -->
  <svg viewBox="0 30 300 220" class="absolute left-0 right-0 top-8 w-full h-[220px] z-10">
    <defs>
      <linearGradient id="streakLine" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#00C49A"/>
        <stop offset="100%" stop-color="#5EE6E8"/>
      </linearGradient>
      <radialGradient id="glowG" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0%" stop-color="#00C49A" stop-opacity="0.9"/>
        <stop offset="100%" stop-color="#00C49A" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <path class='opacity-0' d="M 6 180 C 40 90, 120 80, 170 140 S 250 210, 294 60" fill="none" stroke="url(#streakLine)" stroke-width="2" class:dashdraw={revealed} />

    {#each Array(totalPips) as _, i}
      {#key i}
        {#if i < longestGreenStreak}
          <g class='green-dot' transform={`translate(${6 + (i * (288 / (totalPips - 1)))},${180 - Math.sin(i/2)*40})`}>
            <g class:pip-pop={revealed} style={`--i:${i}`}>
              <circle r="8" fill="#00C49A" opacity="0.95"/>
              <circle r="16" fill="url(#glowG)" opacity="0.55"/>
              <!-- Checkmark icon centered on the pip -->
              <path d="M -4 0 L -1 3 L 5 -3" fill="none" stroke="#0b1f2a" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M -4 0 L -1 3 L 5 -3" fill="none" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" opacity="0.95"/>
            </g>
          </g>
        {:else}
          <circle class='green-dot' r="7" cx={6 + (i * (288 / (totalPips - 1)))} cy={180 - Math.sin(i/2)*40} fill="#ffffff22" class:pip-pop={revealed} style={`--i:${i}`}/>
        {/if}
      {/key}
    {/each}

    <!-- Comet that races along the streak when revealed -->
    <circle r="5" fill="#5EE6E8" class:comet={revealed} />
  </svg>

  <!-- Headline and number -->
  <div class="absolute top-[240px] left-5 right-5 z-10">
    <div class="text-xs uppercase tracking-[0.2em] opacity-80">Longest Green Circles Streak</div>
    <div class="mt-1 text-6xl font-bold montserrat leading-none">{longestGreenStreak}
      <span class="text-base ml-1 align-top opacity-70">days</span>
    </div>
    <!-- {#if longestGreenStreak == null}
      <div class="mt-1 text-[11px] opacity-70">Estimated from your total green days</div>
    {/if} -->
  </div>

  <!-- Legend chips integrated into the background -->
  <!-- <div class="absolute bottom-5 left-5 right-5 flex items-center gap-3 text-[11px] z-10">
    <div class="flex items-center gap-2">
      <span class="h-2.5 w-2.5 rounded-full" style="background:#00C49A"></span>
      <span class="opacity-80">Green {greenCircles}</span>
    </div>
  </div> -->
</div>

<style>
  .dashdraw { opacity: 1 !important; stroke-dasharray: 520; stroke-dashoffset: 520; animation: dash 1200ms ease-out 200ms forwards; }
  @keyframes dash { to { stroke-dashoffset: 0; } }

  .green-dot { opacity: 0; }
  .pip-pop { transform-box: fill-box; transform-origin: center; transform: scale(0.8); opacity: 0; animation: pip 400ms ease-out calc(200ms + (var(--i) * 60ms)) both; }
  @keyframes pip { to { transform: scale(1); opacity: 1; } }

  .comet { offset-path: path('M 6 180 C 40 90, 120 80, 170 140 S 250 210, 294 60'); offset-distance: 0%; animation: race 1400ms ease-in-out 300ms both; filter: drop-shadow(0 0 6px rgba(94,230,232,0.55)); }
  @keyframes race { to { offset-distance: 100%; } }
</style>
